<template>
  <div class="details_form_item">
    <Form :model="dataModel" :label-width="130">
      <FormItem label="标题：">{{dataModel.exceptionTitle}}</FormItem>
      <FormItem label="异常类型：">{{dataModel.excepitonType}}</FormItem>
      <FormItem label="异常内容：">{{dataModel.exceptionContent}}</FormItem>
      <FormItem label="异常明细：">{{dataModel.excepitonDetail}}</FormItem>
      <FormItem label="创建时间：">{{dataModel.createDate}}</FormItem>
      <FormItem label="异常来源：">{{dataModel.exceptionSource}}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  components: {},
  data: function () {
    return {
      dataModel: {},
    };
  },

  created: function () {
    this.dataModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>